module.exports = __webpack_public_path__ + "static/media/user.5f2b0410.svg";